import { render, staticRenderFns } from "./NodaiView.vue?vue&type=template&id=b8157678&scoped=true&"
import script from "./NodaiView.vue?vue&type=script&lang=js&"
export * from "./NodaiView.vue?vue&type=script&lang=js&"
import style0 from "./NodaiView.vue?vue&type=style&index=0&id=b8157678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8157678",
  null
  
)

export default component.exports